import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { AgreementContainer } from '../AgreementContainer';
export var AgreementViewContainer = function AgreementViewContainer() {
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(AgreementContainer, null));
};